export default {
  "nav.home": "Home",
  "nav.howItWorks": "How It Works",
  "nav.about": "About",
  "nav.contact": "Contact",
  "nav.donate": "Donate",
  "nav.login": "Log In",
  "nav.signup": "Sign Up",
  "hero.title1": "Clear Beaches Start",
  "hero.title2": "With You",
  "hero.subtitle": "Donate $14/month, get a free beach cleanup kit with your first donation, and fund kits for local volunteer groups cleaning coastlines every other month.",
  "hero.cta": "Start Donating",
  "hero.secondary": "How It Works",
  "howItWorks.tag": "How It Works",
  "howItWorks.title": "Your Donation Journey",
  "howItWorks.subtitle": "Four simple steps from subscriber to coastline hero",
  "impact.title": "Our Collective Impact",
  "impact.subtitle": "Together we are making beaches cleaner, one kit at a time",
  "features.title": "Why Subscribe?",
  "features.subtitle": "More than just a donation — it is a direct pipeline from your generosity to shoreline action",
  "testimonials.tag": "What People Say",
  "testimonials.title": "Real Stories from Our Coastal Community",
  "cta.title": "Ready to Clean Up Our Beaches?",
  "cta.subtitle": "Join thousands of subscribers funding cleanup kits for their local coastlines. Your first kit is on us.",
  "cta.button": "Start Your $14/month Donation",
  "footer.tagline": "Cleaner beaches, one kit at a time.",
  "footer.rights": "All rights reserved.",
  "about.title": "Our Mission",
  "about.subtitle": "We believe everyone deserves clean, beautiful beaches. Our platform connects generous subscribers with local coastal volunteer groups, turning $14 monthly donations into tangible shoreline cleanup action.",
  "about.story.title": "How It Started",
  "about.story.content": "What began as a small beach cleanup in Santa Monica, California has grown into a nationwide coastal movement. In 2023, our founder organized the first shoreline cleanup with supplies bought out of pocket. The response was overwhelming — beachgoers wanted to keep going, but supplies ran out fast. The subscription model was born from that simple problem: consistent funding means consistent beach cleanups. Today, thousands of subscribers fund kits for hundreds of beaches across the country, proving that small, recurring actions create massive coastal impact.",
  "contact.title": "Get in Touch",
  "contact.subtitle": "Have questions about the program, want to partner with us, or need help with your subscription? We would love to hear from you.",
};